import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="image, heading, text" width="33%" theme="light" className="creatorToolBox" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "198px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "121.21212121212122%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/b40adc1357b1516264737548eb18b7c8/55fac/Creator_Tool_1.webp 198w"],
            "sizes": "(max-width: 198px) 100vw, 198px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/b40adc1357b1516264737548eb18b7c8/c7176/Creator_Tool_1.png 198w"],
            "sizes": "(max-width: 198px) 100vw, 198px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/b40adc1357b1516264737548eb18b7c8/c7176/Creator_Tool_1.png",
            "alt": "Icon showing people becoming connected in a graph",
            "title": "Icon showing people becoming connected in a graph",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "scale-your-reach"
    }}>{`Scale your reach.`}</h3>
    <p>{`Meet marketers, communicators, and small business owners where they create.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="creatorToolBox" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "281px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/4b801f287182d66ecddc88b99b563dd3/dda86/SX_lin_StreamlineDevSupport_140%402x.webp 265w", "/express/add-ons/static/4b801f287182d66ecddc88b99b563dd3/ad69b/SX_lin_StreamlineDevSupport_140%402x.webp 281w"],
            "sizes": "(max-width: 281px) 100vw, 281px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/4b801f287182d66ecddc88b99b563dd3/28773/SX_lin_StreamlineDevSupport_140%402x.png 265w", "/express/add-ons/static/4b801f287182d66ecddc88b99b563dd3/fa392/SX_lin_StreamlineDevSupport_140%402x.png 281w"],
            "sizes": "(max-width: 281px) 100vw, 281px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/4b801f287182d66ecddc88b99b563dd3/fa392/SX_lin_StreamlineDevSupport_140%402x.png",
            "alt": "Icon showing an unlocked padlock",
            "title": "Icon showing an unlocked padlock",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "streamlined-developer-experience"
    }}>{`Streamlined developer experience.`}</h3>
    <p>{`Our “in-app” developer experience is lightweight and approachable, with lots of resources to get you started right away.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="creatorToolBox" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "197px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "121.82741116751271%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/4dd245797a615a5b74b67785c025f514/41ef6/Creator_Tool_2.webp 197w"],
            "sizes": "(max-width: 197px) 100vw, 197px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/4dd245797a615a5b74b67785c025f514/fab3c/Creator_Tool_2.png 197w"],
            "sizes": "(max-width: 197px) 100vw, 197px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/4dd245797a615a5b74b67785c025f514/fab3c/Creator_Tool_2.png",
            "alt": "Hand hovering over an Adobe Express logo, a clock icon to indicate that users' save time, and a lightning bolt to indicate that users' workflows are supercharged",
            "title": "Hand hovering over an Adobe Express logo, a clock icon to indicate that users' save time, and a lightning bolt to indicate that users' workflows are supercharged",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "unlock-new-capabilities"
    }}>{`Unlock new capabilities.`}</h3>
    <p>{`Take advantage of powerful APIs to create custom workflows that target specific user pain points.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      